import classes from './SideBar.module.css';
import { useState} from 'react';

function ToggleExpand(props) {
      
    const [Styles, setStyles] = useState("default");

    let button_style = `${classes.toggle_expand}`; //"nav_button default";

    function handleMouseEnter()
    {
        setStyles("hover");
    }
    function handleMouseLeave()
    {
        setStyles("default");
    }

    if ( Styles==="default" )
    {
        button_style = `${classes.toggle_expand}`; //"nav_button default";
    }
    if ( Styles==="hover" )
    {
        button_style = `${classes.toggle_expand} ${classes.hover}`; //"nav_button hover";
    }

    return(
        <button className={button_style} onClick={props.handleClick} onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}></button>
    );


}


export default ToggleExpand;